<div
  *ngIf="(department$ | async) || (organisation$ | async)"
  class="organisation-heading"
  [class.compact]="compact$ | async"
  data-cy="organisation-heading">
  <mat-icon
    *ngIf="icon$ | async as icon"
    [svgIcon]="icon"
    [matTooltip]="(tooltip$ | async) || '' | i18n"
    class="size-20 organisation-icon"></mat-icon>
  <div
    *ngIf="department$ | async as dept"
    class="job-department"
    [attr.title]="dept.name"
    data-cy="organisation-heading-department">
    {{ dept.name }}
  </div>
  <div
    *ngIf="!(departmentOnly$ | async) && (organisation$ | async) as org"
    class="job-organisation"
    [attr.title]="org.name"
    data-cy="organisation-heading-organisation">
    {{ org.name }}
  </div>
</div>
